// extracted by mini-css-extract-plugin
export var footer = "_ls-5";
export var fulfillmentInput = "_ls-0";
export var shipDateInput = "_ls-1";
export var shipmentModal = "_ls-2";
export var shipmentModalContent = "_ls-3";
export var tableContainer = "_ls-4";